import React from "react";
import { useTranslation } from 'react-i18next';
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  const { t } = useTranslation();
  
  return (
    <div id="history">
      <div className="items-container">
        <h1>{t('timeline.title')}</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date={t('timeline.tinko.date')}
            iconStyle={{ background: 'rgb(254, 202, 66)', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">{t('timeline.tinko.title')}</h3>
            <h4 className="vertical-timeline-element-subtitle">{t('timeline.tinko.location')}</h4>
            <p>
              {t('timeline.tinko.description')}
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date={t('timeline.UiA Makerspace.date')}
            iconStyle={{ background: 'rgb(254, 202, 66)', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">{t('timeline.UiA Makerspace.title')}</h3>
            <h4 className="vertical-timeline-element-subtitle">{t('timeline.UiA Makerspace.location')}</h4>
            <p>
              {t('timeline.UiA Makerspace.description')}
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date={t('timeline.paIntelligence.date')}
            iconStyle={{ background: 'rgb(254, 202, 66)', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">{t('timeline.paIntelligence.title')}</h3>
            <h4 className="vertical-timeline-element-subtitle">{t('timeline.paIntelligence.location')}</h4>
            <p>
              {t('timeline.paIntelligence.description')}
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date={t('timeline.aiveo.date')}
            iconStyle={{ background: 'rgb(254, 202, 66)', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">{t('timeline.aiveo.title')}</h3>
            <h4 className="vertical-timeline-element-subtitle">{t('timeline.aiveo.location')}</h4>
            <p>
              {t('timeline.aiveo.description')}
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={t('timeline.uiaNyskaping.date')}
            iconStyle={{ background: 'rgb(254, 202, 66)', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">{t('timeline.uiaNyskaping.title')}</h3>
            <h4 className="vertical-timeline-element-subtitle">{t('timeline.uiaNyskaping.location')}</h4>
            <p>
              {t('timeline.uiaNyskaping.description')}
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={t('timeline.uiaAssistant.date')}
            iconStyle={{ background: 'rgb(254, 202, 66)', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">{t('timeline.uiaAssistant.title')}</h3>
            <h4 className="vertical-timeline-element-subtitle">{t('timeline.uiaAssistant.location')}</h4>
            <p>
              {t('timeline.uiaAssistant.description')}
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={t('timeline.arendal.date')}
            iconStyle={{ background: 'rgb(254, 202, 66)', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">{t('timeline.arendal.title')}</h3>
            <h4 className="vertical-timeline-element-subtitle">{t('timeline.arendal.location')}</h4>
            <p>
              {t('timeline.arendal.description')}
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
